import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toArray from "@babel/runtime/helpers/esm/toArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { useEffect, useState } from 'react';
import useApiGet from './useApiGet';
import useProfile from './useProfile';
export default (function (_ref) {
  var path = _ref.path,
      parse = _ref.parse,
      args = _objectWithoutProperties(_ref, ["path", "parse"]);

  var _useProfile = useProfile(),
      _useProfile2 = _slicedToArray(_useProfile, 1),
      profileData = _useProfile2[0];

  var _useApiGet = useApiGet(_objectSpread({
    parse: function parse(o) {
      return o;
    }
  }, args)),
      _useApiGet2 = _toArray(_useApiGet),
      response = _useApiGet2[0],
      setPath = _useApiGet2[1],
      api = _useApiGet2.slice(2);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var loadResponse = function loadResponse() {
    return setData(parse(response, profileData));
  };

  useEffect(function () {
    return profileData && setPath(path);
  }, [profileData]);
  useEffect(function () {
    return response && loadResponse();
  }, [response]);
  return [data, setPath].concat(_toConsumableArray(api));
});